/*======================================================================================================================
  * Bluebell: src/app/state/assembly-libraries/assembly-library.selectors.ts
  * Last Edited: 14/02/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { Dictionary } from '@ngrx/entity';
import { AssemblyLibrary } from '@state/assembly-libraries/assembly-library.interfaces';
import * as fromAssemblyLibraries from '@state/assembly-libraries/assembly-library.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';


export const selectAssemblyLibrariesState = createFeatureSelector<fromAssemblyLibraries.State>(fromAssemblyLibraries.featureKey);

export const selectAllAssemblyLibrariesUnfiltered = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getAll
);

export const selectAssemblyLibraryEntities = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getEntities
);

export const selectAssemblyLibraryIds = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getIds
);

export const selectAssemblyLibraryTotal = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getTotal
);

export const selectAssemblyLibrariesLoading = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getLoading
);

export const selectAssemblyLibrariesLoaded = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getLoaded
);

export const selectAssemblyLibrariesLoadInactive = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getLoadInactive
);

export const selectAssemblyLibrariesInactiveLibrariesLoaded = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getInactiveLibrariesLoaded
);

export const selectExpandedAssemblyLibraryIds = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getExpandedLibraries
);

export const selectAssemblyLibrarySearchString = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getSearchString
);

export const selectSelectedAssembly = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getSelectedAssembly
);

export const selectSelectedAssemblyLoading = createSelector(
  selectAssemblyLibrariesState,
  fromAssemblyLibraries.getSelectedAssemblyLoading
);

// Complex Selectors

export const selectAllAssemblyLibraries = createSelector(
  selectAllAssemblyLibrariesUnfiltered,
  selectAssemblyLibrariesLoadInactive,
  (libraries: AssemblyLibrary[], loadInactive: boolean) => loadInactive
    ? libraries
    : libraries.filter(library => library.active)
);

export const selectExpandedAssemblyLibraries = createSelector(
  selectAssemblyLibraryEntities,
  selectExpandedAssemblyLibraryIds,
  (entities: Dictionary<AssemblyLibrary>, ids: string[]) => ids.map(id => entities[id])
);

